const KEY = 'login-redirect'

/**
 * Remembers the page someone wanted to open before being sent to the login, so
 * they land there afterwards. Both login providers return to the app root, so
 * the target cannot travel through the login itself. Session storage keeps it
 * per tab and drops it when the tab closes.
 */
export function useLoginRedirect() {
  function isInternal(path: string) {
    // No protocol relative paths (open redirect) and no login pages (loop).
    return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/login')
  }

  function remember(path: string) {
    if (!import.meta.client || !isInternal(path)) return

    sessionStorage.setItem(KEY, path)
  }

  function take() {
    if (!import.meta.client) return null

    const path = sessionStorage.getItem(KEY)
    sessionStorage.removeItem(KEY)

    return path && isInternal(path) ? path : null
  }

  return { remember, take }
}
